export interface DeaktivierungsGrund {
  id          : number;
  bezeichnung : string;
  textDe      : string;
  textFr      : string;
  textIt      : string;
}

export interface DeaktivierungsGrundAdmin {
  id            : number;
  bezeichnungDe : string;
  bezeichnungFr : string;
  bezeichnungIt : string;
  textDe        : string;
  textFr        : string;
  textIt        : string;
  sortierung    : number;
}

export class DeaktivierungsGrundAdminCmd {
  id            ?: number;
  bezeichnungDe  : string | null = null;
  bezeichnungFr  : string | null = null;
  bezeichnungIt  : string | null = null;
  textDe         : string | null = null;
  textFr         : string | null = null;
  textIt         : string | null = null;
  sortierung     : number | null = null;

  public constructor(init?: Partial<DeaktivierungsGrundAdminCmd>) {
    Object.assign(this, init);
  }
}
